import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function SignupPage() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!firstName.trim() || !lastName.trim() || !email.trim() || !password.trim()) {
      setError('Todos los campos son obligatorios.');
      return;
    }
    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }
    setLoading(true);
    // Store user in localStorage
    const users = JSON.parse(localStorage.getItem('awc_users') || '[]');
    const existingUser = users.find((u: {
      email: string;
    }) => u.email === email.toLowerCase());
    if (existingUser) {
      setError('Ya existe una cuenta con este correo electrónico.');
      setLoading(false);
      return;
    }
    users.push({
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email.toLowerCase().trim(),
      password: password,
      createdAt: new Date().toISOString()
    });
    localStorage.setItem('awc_users', JSON.stringify(users));
    // Redirect to login
    setTimeout(() => {
      window.location.href = '/login';
    }, 500);
  };
  return <div className="flex min-h-screen items-center justify-center bg-[#0a0a0a] px-4 py-12 font-body" data-id="element-2207">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4
    }} className="w-full max-w-[440px]" data-id="element-2208">
        {/* Logo */}
        <div className="mb-10 text-center" data-id="element-2209">
          <a href="/" className="inline-block font-heading text-[15px] font-black tracking-[3px] text-white uppercase" data-id="element-2210">
            AI <span className="text-[#F5C842]" data-id="element-2211">WEB CLOSER</span>
          </a>
          <div className="mt-2 text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-2212">
            Crea tu cuenta
          </div>
        </div>

        {/* Card */}
        <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-2213">
          <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-6 py-3.5" data-id="element-2214">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-2215"></div>
            <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2216">
              Registro de Miembro
            </div>
          </div>

          <form onSubmit={handleSubmit} className="px-6 py-6" data-id="element-2217">
            {error && <div className="mb-4 rounded-r-lg border border-[#3a1a1a] border-l-[3px] border-l-[#ff6b6b] bg-[#1a0a0a] px-4 py-3 text-[12px] text-[#ff6b6b]" data-id="element-2218">
                {error}
              </div>}

            <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-2219">
              <div data-id="element-2220">
                <label className="mb-1.5 block text-[11px] font-bold tracking-[1px] text-[#555] uppercase" data-id="element-2221">
                  Nombre
                </label>
                <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="Juan" className="w-full rounded-md border border-[#1e1e1e] bg-[#0a0a0a] px-4 py-3 text-[13px] text-white placeholder-[#333] outline-none transition-colors focus:border-[#F5C842]" data-id="element-2222" />
              </div>
              <div data-id="element-2223">
                <label className="mb-1.5 block text-[11px] font-bold tracking-[1px] text-[#555] uppercase" data-id="element-2224">
                  Apellido
                </label>
                <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Pérez" className="w-full rounded-md border border-[#1e1e1e] bg-[#0a0a0a] px-4 py-3 text-[13px] text-white placeholder-[#333] outline-none transition-colors focus:border-[#F5C842]" data-id="element-2225" />
              </div>
            </div>

            <div className="mb-4" data-id="element-2226">
              <label className="mb-1.5 block text-[11px] font-bold tracking-[1px] text-[#555] uppercase" data-id="element-2227">
                Correo Electrónico
              </label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@email.com" className="w-full rounded-md border border-[#1e1e1e] bg-[#0a0a0a] px-4 py-3 text-[13px] text-white placeholder-[#333] outline-none transition-colors focus:border-[#F5C842]" data-id="element-2228" />
            </div>

            <div className="mb-6" data-id="element-2229">
              <label className="mb-1.5 block text-[11px] font-bold tracking-[1px] text-[#555] uppercase" data-id="element-2230">
                Contraseña
              </label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Mínimo 6 caracteres" className="w-full rounded-md border border-[#1e1e1e] bg-[#0a0a0a] px-4 py-3 text-[13px] text-white placeholder-[#333] outline-none transition-colors focus:border-[#F5C842]" data-id="element-2231" />
            </div>

            <button type="submit" disabled={loading} className="w-full rounded-md bg-[#F5C842] px-6 py-3.5 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-90 disabled:opacity-50" data-id="element-2232">
              {loading ? 'Creando cuenta...' : 'Crear Mi Cuenta'}
            </button>
          </form>
        </div>

        {/* Login link */}
        <div className="mt-6 text-center text-[12px] text-[#555]" data-id="element-2233">
          ¿Ya tienes cuenta?{' '}
          <a href="/login" className="font-bold text-[#F5C842] transition-colors hover:text-white" data-id="element-2234">
            Inicia Sesión
          </a>
        </div>
      </motion.div>
    </div>;
}